import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
// eslint-disable-next-line @typescript-eslint/naming-convention
import Bolt from '@nationwide-bolt/bundle-core';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

Bolt.initialize()
    .then(() => bootstrapApplication(AppComponent, appConfig))
    .catch((err: unknown) => { throw err; });